export default {
  id: "calendar",
  i18nTitle: "tours.calendar.title",
  steps: [
    {
      id: "calendar.welcome",
      target: null,
      path: "/appointments",
      i18nBody: "tours.calendar.step1.body",
    },
    {
      id: "calendar.newAppointment",
      target: "new-appointment-btn",
      path: "/appointments",
      i18nBody: "tours.calendar.step2.body",
    },
    {
      id: "calendar.client",
      target: "appointment-client-picker",
      path: "/create-appointment",
      i18nBody: "tours.calendar.step3.body",
    },
    {
      id: "calendar.confirm",
      target: "appointment-confirm",
      path: "/create-appointment",
      i18nBody: "tours.calendar.step4.body",
    },
  ],
};
